import React from 'react';
import { token } from '@atlaskit/tokens';

export const IncidentsGlyph = (props: { [key: string]: string }) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		focusable="false"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.8716 5.54947C12.7818 5.38984 12.6499 5.25794 12.4903 5.16815C12.0089 4.89739 11.3992 5.06811 11.1284 5.54947L3.83826 18.5097C3.75407 18.6594 3.70984 18.8283 3.70984 19C3.70984 19.5523 4.15755 20 4.70984 20H19.2901C19.4619 20 19.6307 19.9558 19.7804 19.8716C20.2618 19.6008 20.4325 18.9911 20.1617 18.5097L12.8716 5.54947ZM12 9.09932L16.7254 17.5H7.27461L12 9.09932Z"
			fill="currentColor"
		/>
	</svg>
);

export const ChangesGlyph = (props: { [key: string]: string }) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		focusable="false"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.4123 10.1551C12.8378 10.1525 12.3701 9.68475 12.3675 9.11027L12.3598 7.39768L5.63605 14.1215C5.24553 14.512 4.61236 14.512 4.22184 14.1215C3.83132 13.731 3.83132 13.0978 4.22184 12.7073L10.9456 5.98347L9.23304 5.97583C8.65857 5.97326 8.19079 5.50548 8.18823 4.93101C8.18567 4.35654 8.64929 3.89291 9.22376 3.89548L13.3845 3.91404C13.9589 3.9166 14.4267 4.38438 14.4293 4.95886L14.4478 9.11955C14.4504 9.69403 13.9868 10.1577 13.4123 10.1551Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.8118 19.0691C15.8093 18.4946 15.3415 18.0269 14.767 18.0243L13.0544 18.0166L19.7782 11.2929C20.1687 10.9023 20.1687 10.2692 19.7782 9.87864C19.3877 9.48812 18.7545 9.48811 18.364 9.87864L11.6402 16.6024L11.6326 14.8898C11.63 14.3154 11.1622 13.8476 10.5877 13.845C10.0133 13.8425 9.54965 14.3061 9.55222 14.8806L9.57078 19.0413C9.57334 19.6157 10.0411 20.0835 10.6156 20.0861L14.7763 20.1046C15.3508 20.1072 15.8144 19.6436 15.8118 19.0691Z"
			fill="currentColor"
		/>
		<mask
			id="mask0"
			mask-type="alpha"
			maskUnits="userSpaceOnUse"
			x="7"
			y="7"
			width="16"
			height="16"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.8118 19.0691C15.8093 18.4946 15.3415 18.0269 14.767 18.0243L13.0544 18.0166L19.7782 11.2929C20.1687 10.9023 20.1687 10.2692 19.7782 9.87864C19.3877 9.48812 18.7545 9.48811 18.364 9.87864L11.6402 16.6024L11.6326 14.8898C11.63 14.3154 11.1622 13.8476 10.5877 13.845C10.0133 13.8425 9.54965 14.3061 9.55222 14.8806L9.57078 19.0413C9.57334 19.6157 10.0411 20.0835 10.6156 20.0861L14.7763 20.1046C15.3508 20.1072 15.8144 19.6436 15.8118 19.0691Z"
				fill={token('color.icon.inverse')}
			/>
		</mask>
		<g mask="url(#mask0)" />
	</svg>
);

export const ProblemsGlyph = (props: { [key: string]: string }) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		focusable="false"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM17.3946 8.37281L8.37281 17.3946C9.40883 18.0926 10.6568 18.5 12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 10.6568 18.0926 9.40883 17.3946 8.37281ZM5.5 12C5.5 8.41015 8.41015 5.5 12 5.5C13.3432 5.5 14.5912 5.9074 15.6272 6.60536L6.60536 15.6272C5.9074 14.5912 5.5 13.3432 5.5 12Z"
			fill="currentColor"
		/>
	</svg>
);

export const ServiceRequestsGlyph = (props: { [key: string]: string }) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		focusable="false"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 4C16.4183 4 20 7.13401 20 11C20 14.866 16.4183 18 12 18C11.2426 18 10.5098 17.9079 9.81538 17.7358L9.48536 17.9384C8.76804 18.3682 7.14214 19.3047 4.60766 20.748L5.41439 17.3256C5.60252 16.5045 5.73944 15.8795 5.82514 15.4509C4.6849 14.2411 4 12.6905 4 11C4 7.13401 7.58172 4 12 4ZM12 6C8.68629 6 6 8.23858 6 11C6 13.7614 8.68629 16 12 16C15.3137 16 18 13.7614 18 11C18 8.23858 15.3137 6 12 6Z"
			fill="currentColor"
		/>
	</svg>
);

// Copied svg from Figma
export const PostIncidentReviewsGlyph = (props: { [key: string]: string }) => (
	<svg
		{...props}
		width="24"
		height="24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		focusable="false"
	>
		<path fill={token('color.icon.inverse')} fillOpacity=".01" d="M0 0h24v24H0z" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6 17H5V7h1V5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1v-2Zm13-6.995V19H9V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H9a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995h-2Z"
			fill={token('color.icon')}
		/>
	</svg>
);

export const NoPracticeGlyph = (props: { [key: string]: string }) => (
	<svg {...props} width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation">
		<path
			d="M19 5h.006C20.107 5 21 5.895 21 6.994v12.012A1.995 1.995 0 0 1 19.006 21H6.994A1.995 1.995 0 0 1 5 19.006V19h13c.555 0 1-.448 1-1V5zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0 1 14.994 17H5.006A2.005 2.005 0 0 1 3 14.994V5.006zM5 5v10h10V5H5zm1 3c0-.552.453-1 .997-1h6.006c.55 0 .997.444.997 1 0 .552-.453 1-.997 1H6.997A.996.996 0 0 1 6 8zm0 3c0-.552.453-1 .997-1h6.006c.55 0 .997.444.997 1 0 .552-.453 1-.997 1H6.997A.996.996 0 0 1 6 11z"
			fill="currentColor"
		/>
	</svg>
);

export const ServicesGlyph = (props: { [key: string]: string }) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20 6C20 7.10457 19.1046 8 18 8C16.8954 8 16 7.10457 16 6C16 4.89543 16.8954 4 18 4C19.1046 4 20 4.89543 20 6ZM20 18C20 19.1046 19.1046 20 18 20C16.8954 20 16 19.1046 16 18C16 16.8954 16.8954 16 18 16C19.1046 16 20 16.8954 20 18ZM18 10C20.2091 10 22 8.20914 22 6C22 3.79086 20.2091 2 18 2C15.7909 2 14 3.79086 14 6C14 8.20914 15.7909 10 18 10ZM18 22C20.2091 22 22 20.2091 22 18C22 15.7909 20.2091 14 18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22ZM11.1377 5C10.803 5 10.4904 5.16747 10.3051 5.44617L9.28468 6.98023C8.97881 7.44008 9.10363 8.06082 9.56348 8.36669C10.0233 8.67256 10.6441 8.54774 10.9499 8.08789L11.6736 7H12.5688C13.1211 7 13.5688 6.55228 13.5688 6C13.5688 5.44772 13.1211 5 12.5688 5H11.1377ZM8.90917 11.156C9.21504 10.6962 9.09022 10.0754 8.63037 9.76954C8.17052 9.46367 7.54978 9.5885 7.24391 10.0483L6.49738 11.1707C6.19106 11.377 6.03512 11.7238 6.0583 12.0681C6.03512 12.4124 6.19106 12.7592 6.49738 12.9656L7.24391 14.0879C7.54978 14.5477 8.17052 14.6726 8.63037 14.3667C9.09022 14.0608 9.21504 13.4401 8.90917 12.9802L8.30247 12.0681L8.90917 11.156ZM3 11C2.44772 11 2 11.4477 2 12C2 12.0229 2.00077 12.0456 2.00228 12.0681C2.00077 12.0906 2 12.1133 2 12.1362C2 12.6885 2.44772 13.1362 3 13.1362H5.02808C5.58036 13.1362 6.02808 12.6885 6.02808 12.1362C6.02808 12.1133 6.02731 12.0906 6.02579 12.0681C6.02731 12.0456 6.02808 12.0229 6.02808 12C6.02808 11.4477 5.58036 11 5.02808 11H3ZM10.9499 16.0483C10.6441 15.5885 10.0233 15.4637 9.56348 15.7695C9.10363 16.0754 8.97881 16.6962 9.28468 17.156L10.3051 18.6901C10.4904 18.9688 10.803 19.1362 11.1377 19.1362H12.5688C13.1211 19.1362 13.5688 18.6885 13.5688 18.1362C13.5688 17.5839 13.1211 17.1362 12.5688 17.1362H11.6736L10.9499 16.0483Z"
			fill="currentColor"
		/>
	</svg>
);
